const TABLE_ROWS_PER_PAGE: number[] = [10, 25, 100];
export { TABLE_ROWS_PER_PAGE };
